import { gql } from '@apollo/client';
import { useToast } from '@chakra-ui/react';
import { useCallback } from 'react';
import { fromError } from '~utils/errors';
import { useRemovePowerScheduleFromDisplaysMutation } from './__generated__/useRemovePowerScheduleFromDisplays.graphql';

export function useRemovePowerScheduleFromDisplays() {
  const toast = useToast();
  const [removePowerScheduleFromDisplaysMutation, { loading }] =
    useRemovePowerScheduleFromDisplaysMutation();

  const removePowerScheduleFromDisplays = useCallback(
    async (displayIds: string[]) => {
      try {
        await removePowerScheduleFromDisplaysMutation({
          variables: { displayIds },
        });
      } catch (err) {
        toast({
          status: 'error',
          title: 'Cannot remove power schedule from displays',
          description: fromError(err, 'UpdatePowerSchedule'),
        });
      }
    },
    [removePowerScheduleFromDisplaysMutation, toast],
  );

  return { removePowerScheduleFromDisplays, loading };
}

useRemovePowerScheduleFromDisplays.graphql = {
  fragments: {
    useRemovePowerScheduleFromDisplays_powerSchedule: gql`
      fragment useRemovePowerScheduleFromDisplays_powerSchedule on PowerSchedule {
        id
        removingDisplays: displays(filter: { state: REMOVING }) {
          id
        }
      }
    `,
  },
  mutations: {
    RemovePowerScheduleFromDisplays: gql`
      mutation RemovePowerScheduleFromDisplays($displayIds: [ID!]!) {
        displayBulkUpdatePowerSchedule(input: { displayIds: $displayIds, powerScheduleId: null }) {
          displays {
            id
            powerSchedule {
              schedule {
                id
                title
                ...useRemovePowerScheduleFromDisplays_powerSchedule
              }
            }
          }
        }
      }
    `,
  },
};
